import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lms-help-doc',
  templateUrl: './help-doc.component.html',
  styleUrls: ['./help-doc.component.scss']
})
export class HelpDocComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
